import { render, staticRenderFns } from "./ChangeAddressModal.vue?vue&type=template&id=18f4bb96&scoped=true&"
import script from "./ChangeAddressModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAddressModal.vue?vue&type=style&index=0&id=18f4bb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4bb96",
  null
  
)

export default component.exports